// shared utility for converting <img> data URIs to uploaded URLs
// returns the transformed HTML string; any images that fail to upload are left as-is
import { AddStoryImage } from '../services/donation';

export default async function replaceBase64WithUploadedUrls(html) {
  const imgRegex = /<img[^>]+src="([^"]+)"/g;
  const matches = [...html.matchAll(imgRegex)].map((m) => m[1]).filter(Boolean);
  const base64s = [...new Set(matches.filter((src) => src && src.startsWith('data:')))];

  if (base64s.length === 0) return html;

  const uploadPromises = base64s.map((src) => (
    fetch(src)
      .then((res) => res.blob())
      .then((blob) => {
        const formDataImg = new FormData();
        formDataImg.append('storyDescriptionImage', blob, 'clipboard.png');
        return AddStoryImage(formDataImg);
      })
      .then((resp) => {
        if (!resp.ok) throw new Error('upload failed');
        return resp.text();
      })
      .then((url) => ({ src, url }))
      .catch((err) => {
        console.error('failed to upload pasted image', err);
        return { src, url: null };
      })
  ));

  const results = await Promise.all(uploadPromises);
  let updatedHtml = html;
  results.forEach((r) => {
    if (r.url) updatedHtml = updatedHtml.split(r.src).join(r.url);
  });
  return updatedHtml;
}
